import { memo } from 'react';
import { Link } from 'react-router-dom';

const FONT_STYLE = Object.freeze({ fontFamily: 'Manrope, sans-serif' });

const PublicNavMobileLink = memo(function PublicNavMobileLink({
  link,
  isDark,
  isActive,
  onNavigate,
}) {
  const inactiveClass = isDark
    ? 'text-white/80 hover:bg-white/10 hover:text-white'
    : 'text-slate-600 hover:bg-indigo-50 hover:text-indigo-600';

  const rowClass = `block w-full text-left px-3 py-2.5 text-sm font-medium rounded-lg transition-colors ${
    isActive ? 'bg-indigo-50 text-indigo-600' : inactiveClass
  }`;

  const childClass = `block w-full text-left pl-7 pr-3 py-2 text-sm rounded-lg transition-colors ${
    isDark ? 'text-white/60 hover:text-white' : 'text-slate-500 hover:text-indigo-600'
  }`;

  const row = link.hash && link.pathname === '/' ? (
    <a href={link.href} onClick={onNavigate} className={rowClass} style={FONT_STYLE} data-testid={link.testId}>
      {link.label}
    </a>
  ) : (
    <Link
      to={link.routerTo}
      onClick={onNavigate}
      target={link.openInNewTab ? '_blank' : undefined}
      rel={link.openInNewTab ? 'noopener noreferrer' : undefined}
      className={rowClass}
      style={FONT_STYLE}
      data-testid={link.testId}
    >
      {link.label}
    </Link>
  );

  return (
    <div>
      {row}
      {link.children.map((child) => (
        child.hash && child.pathname === '/' ? (
          <a key={child.id} href={child.href} onClick={onNavigate} className={childClass} style={FONT_STYLE}>
            {child.label}
          </a>
        ) : (
          <Link
            key={child.id}
            to={child.routerTo}
            onClick={onNavigate}
            target={child.openInNewTab ? '_blank' : undefined}
            rel={child.openInNewTab ? 'noopener noreferrer' : undefined}
            className={childClass}
            style={FONT_STYLE}
          >
            {child.label}
          </Link>
        )
      ))}
    </div>
  );
});

export default PublicNavMobileLink;
